require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.starts-with");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var _ = require('lodash');

var prefixNegativeModifiers = function prefixNegativeModifiers(base, modifier) {
  return _.startsWith(modifier, '-') ? "-" + base + "-" + modifier.slice(1) : base + "-" + modifier;
};

module.exports = function (options) {
  if (options === void 0) {
    options = {};
  }

  return function (_ref) {
    var theme = _ref.theme,
        variants = _ref.variants,
        e = _ref.e,
        addUtilities = _ref.addUtilities;
    var defaultOptions = {
      '3d': false
    };
    options = _.defaults({}, options, defaultOptions);
    var defaultTransformTheme = {
      'none': 'none'
    };
    var defaultTransformVariants = ['responsive'];
    var defaultTransformOriginTheme = {
      't': 'top',
      'tr': 'top right',
      'r': 'right',
      'br': 'bottom right',
      'b': 'bottom',
      'bl': 'bottom left',
      'l': 'left',
      'tl': 'top left'
    };
    var defaultTransformOriginVariants = ['responsive'];
    var defaultTranslateTheme = {};
    var defaultTranslateVariants = ['responsive'];
    var defaultScaleTheme = {};
    var defaultScaleVariants = ['responsive'];
    var defaultRotateTheme = {};
    var defaultRotateVariants = ['responsive'];
    var defaultSkewTheme = {};
    var defaultSkewVariants = ['responsive'];
    var defaultPerspectiveTheme = {};
    var defaultPerspectiveVariants = ['responsive'];
    var defaultPerspectiveOriginTheme = {
      't': 'top',
      'tr': 'top right',
      'r': 'right',
      'br': 'bottom right',
      'b': 'bottom',
      'bl': 'bottom left',
      'l': 'left',
      'tl': 'top left'
    };
    var defaultPerspectiveOriginVariants = ['responsive'];
    var defaultTransformStyleVariants = ['responsive'];
    var defaultBackfaceVisibilityVariants = ['responsive'];
    var defaultTransformBoxVariants = ['responsive'];
    var transformTheme = theme('transform', defaultTransformTheme);
    var transformVariants = variants('transform', defaultTransformVariants);
    var transformOriginTheme = theme('transformOrigin', defaultTransformOriginTheme);
    var transformOriginVariants = variants('transformOrigin', defaultTransformOriginVariants);
    var translateTheme = theme('translate', defaultTranslateTheme);
    var translateVariants = variants('translate', defaultTranslateVariants);
    var scaleTheme = theme('scale', defaultScaleTheme);
    var scaleVariants = variants('scale', defaultScaleVariants);
    var rotateTheme = theme('rotate', defaultRotateTheme);
    var rotateVariants = variants('rotate', defaultRotateVariants);
    var skewTheme = theme('skew', defaultSkewTheme);
    var skewVariants = variants('skew', defaultSkewVariants);
    var perspectiveTheme = theme('perspective', defaultPerspectiveTheme);
    var perspectiveVariants = variants('perspective', defaultPerspectiveVariants);
    var perspectiveOriginTheme = theme('perspectiveOrigin', defaultPerspectiveOriginTheme);
    var perspectiveOriginVariants = variants('perspectiveOrigin', defaultPerspectiveOriginVariants);
    var transformStyleVariants = variants('transformStyle', defaultTransformStyleVariants);
    var backfaceVisibilityVariants = variants('backfaceVisibility', defaultBackfaceVisibilityVariants);
    var transformBoxVariants = variants('transformBox', defaultTransformBoxVariants);

    var transformUtilities = _.fromPairs(_.map(transformTheme, function (value, modifier) {
      return ["." + e("transform-" + modifier), {
        transform: value
      }];
    }));

    var transformOriginUtilities = _.fromPairs(_.map(transformOriginTheme, function (value, modifier) {
      return ["." + e("transform-" + modifier), {
        transformOrigin: value
      }];
    }));

    var translateUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(translateTheme, function (value, modifier) {
      if (_.isArray(value)) {
        if (value.length === 0) {
          return [];
        }

        if (value.length >= 3) {
          return [["." + e(prefixNegativeModifiers('translate', modifier)), {
            transform: "translate3d(" + value[0] + ", " + value[1] + ", " + value[2] + ")"
          }]];
        }

        if (value.length >= 2) {
          return [["." + e(prefixNegativeModifiers('translate', modifier)), {
            transform: "translate(" + value[0] + ", " + value[1] + ")"
          }]];
        }

        value = value[0];
      }

      return [["." + e(prefixNegativeModifiers('translate-x', modifier)), {
        transform: "translateX(" + value + ")"
      }], ["." + e(prefixNegativeModifiers('translate-y', modifier)), {
        transform: "translateY(" + value + ")"
      }]].concat(_toConsumableArray(!options['3d'] ? [] : [["." + e(prefixNegativeModifiers('translate-z', modifier)), {
        transform: "translateZ(" + value + ")"
      }]]));
    }))));

    var scaleUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(scaleTheme, function (value, modifier) {
      if (_.isArray(value)) {
        if (value.length === 0) {
          return [];
        }

        if (value.length >= 3) {
          return [["." + e(prefixNegativeModifiers('scale', modifier)), {
            transform: "scale3d(" + value[0] + ", " + value[1] + ", " + value[2] + ")"
          }]];
        }

        if (value.length >= 2) {
          return [["." + e(prefixNegativeModifiers('scale', modifier)), {
            transform: "scale(" + value[0] + ", " + value[1] + ")"
          }]];
        }

        value = value[0];
      }

      return [["." + e(prefixNegativeModifiers('scale', modifier)), {
        transform: "scale(" + value + ")"
      }], ["." + e(prefixNegativeModifiers('scale-x', modifier)), {
        transform: "scaleX(" + value + ")"
      }], ["." + e(prefixNegativeModifiers('scale-y', modifier)), {
        transform: "scaleY(" + value + ")"
      }]].concat(_toConsumableArray(!options['3d'] ? [] : [["." + e(prefixNegativeModifiers('scale-z', modifier)), {
        transform: "scaleZ(" + value + ")"
      }]]));
    }))));

    var rotateUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(rotateTheme, function (value, modifier) {
      if (_.isArray(value)) {
        if (value.length === 0) {
          return [];
        }

        if (value.length >= 4) {
          return [["." + e(prefixNegativeModifiers('rotate', modifier)), {
            transform: "rotate3d(" + value[0] + ", " + value[1] + ", " + value[2] + ", " + value[3] + ")"
          }]];
        }

        value = value[0];
      }

      return [["." + e(prefixNegativeModifiers('rotate', modifier)), {
        transform: "rotate(" + value + ")"
      }]].concat(_toConsumableArray(!options['3d'] ? [] : [["." + e(prefixNegativeModifiers('rotate-x', modifier)), {
        transform: "rotateX(" + value + ")"
      }], ["." + e(prefixNegativeModifiers('rotate-y', modifier)), {
        transform: "rotateY(" + value + ")"
      }]]));
    }))));

    var skewUtilities = _.fromPairs(_.concat.apply(_, _toConsumableArray(_.map(skewTheme, function (value, modifier) {
      return [["." + e(prefixNegativeModifiers('skew-x', modifier)), {
        transform: "skewX(" + value + ")"
      }], ["." + e(prefixNegativeModifiers('skew-y', modifier)), {
        transform: "skewY(" + value + ")"
      }]];
    }))));

    var perspectiveUtilities = _.fromPairs(_.map(perspectiveTheme, function (value, modifier) {
      return ["." + e("perspective-" + modifier), {
        perspective: value
      }];
    }));

    var perspectiveOriginUtilities = _.fromPairs(_.map(perspectiveOriginTheme, function (value, modifier) {
      return ["." + e("perspective-" + modifier), {
        perspectiveOrigin: value
      }];
    }));

    var transformStyleUtilities = {
      '.transform-flat': {
        transformStyle: 'flat'
      },
      '.transform-preserve-3d': {
        transformStyle: 'preserve-3d'
      }
    };
    var backfaceVisibilityUtilities = {
      '.backface-visible': {
        backfaceVisibility: 'visible'
      },
      '.backface-hidden': {
        backfaceVisibility: 'hidden'
      }
    };
    var transformBoxUtilities = {
      '.transform-border': {
        transformBox: 'border-box'
      },
      '.transform-fill': {
        transformBox: 'fill-box'
      },
      '.transform-view': {
        transformBox: 'view-box'
      }
    };
    addUtilities(transformUtilities, transformVariants);
    addUtilities(transformOriginUtilities, transformOriginVariants);
    addUtilities(translateUtilities, translateVariants);
    addUtilities(scaleUtilities, scaleVariants);
    addUtilities(rotateUtilities, rotateVariants);
    addUtilities(skewUtilities, skewVariants);

    if (options['3d']) {
      addUtilities(perspectiveUtilities, perspectiveVariants);
      addUtilities(perspectiveOriginUtilities, perspectiveOriginVariants);
      addUtilities(transformStyleUtilities, transformStyleVariants);
      addUtilities(backfaceVisibilityUtilities, backfaceVisibilityVariants);
    }

    addUtilities(transformBoxUtilities, transformBoxVariants);
  };
};